/* tslint:disable */
/* eslint-disable */
/**
 * OSB Workspaces manager API
 * Opensource Brain Platform - Reference Workspaces manager API
 *
 * The version of the OpenAPI document: 0.2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Repository type:
 *   * dandi - DANDI repository
 *   * figshare - FigShare repository
 *   * github - Github repository
 * @export
 * @enum {string}
 */
export enum RepositoryType {
    Dandi = 'dandi',
    Figshare = 'figshare',
    Github = 'github',
    Biomodels = 'biomodels'
}

export function RepositoryTypeFromJSON(json: any): RepositoryType {
    return RepositoryTypeFromJSONTyped(json, false);
}

export function RepositoryTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): RepositoryType {
    return json as RepositoryType;
}

export function RepositoryTypeToJSON(value?: RepositoryType | null): any {
    return value as any;
}

